module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Chavannes-pres-Renens-ee5c0943d354447bfba6c2a7d34e0f6e.svg";